// =======================
// Magnify.js
// =======================

// Create overlay with full-size background
function createOverlay(image) {
  const fullSrc = image.getAttribute('data-zoom-src') || image.src;
  const overlayImage = document.createElement('img');
  overlayImage.setAttribute('src', fullSrc);

  const overlay = document.createElement('div');
  prepareOverlay(overlay, fullSrc);

  image.style.opacity = '50%';
  toggleLoadingSpinner(image);

  overlayImage.onload = () => {
    toggleLoadingSpinner(image);
    image.parentElement.insertBefore(overlay, image);
    image.style.opacity = '100%';
  };

  return overlay;
}

// Prepare overlay container
function prepareOverlay(container, src) {
  container.setAttribute('class', 'image-magnify-full-size');
  container.setAttribute('aria-hidden', 'true');
  container.style.backgroundImage = `url('${src}')`;
  container.style.backgroundColor = 'var(--gradient-background)';
  container.style.cursor = "zoom-out";
}

// Toggle loading spinner while image loads
function toggleLoadingSpinner(image) {
  const loadingSpinner = image.parentElement.querySelector('.loading__spinner');
  if (loadingSpinner) {
    loadingSpinner.classList.toggle('hidden');
  }
}

// Move zoomed background with mouse
function moveWithHover(image, overlay, event, zoomRatio) {
  const ratio = image.height / image.width;
  const container = event.target.getBoundingClientRect();
  const xPosition = event.clientX - container.left;
  const yPosition = event.clientY - container.top;

  const xPercent = `${xPosition / (image.clientWidth / 100)}%`;
  const yPercent = `${yPosition / ((image.clientWidth * ratio) / 100)}%`;

  overlay.style.backgroundPosition = `${xPercent} ${yPercent}`;
  overlay.style.backgroundSize = `${image.width * zoomRatio}px`;
}

// Create magnifier overlay
function magnify(image, zoomRatio) {
  const overlay = createOverlay(image);

  overlay.onclick = () => overlay.remove();
  overlay.onmousemove = (event) => moveWithHover(image, overlay, event, zoomRatio);
  overlay.onmouseleave = () => overlay.remove();

  return overlay;
}

// Enable click-to-zoom toggle
function enableZoomOnHover(zoomRatio) {
  const images = document.querySelectorAll('.image-magnify-hover');

  images.forEach((image) => {
    let isZoomed = false;
    let activeOverlay = null;

    image.style.cursor = "zoom-in";

    image.onclick = (event) => {
      if (isZoomed) {
        if (activeOverlay) activeOverlay.remove();
        isZoomed = false;
      } else {
        activeOverlay = magnify(image, zoomRatio);
        moveWithHover(image, activeOverlay, event, zoomRatio);
        isZoomed = true;
      }
    };
  });
}

// Initialize with zoom ratio 2x
enableZoomOnHover(2);

// Re-bind when Shopify sections reload
document.addEventListener('shopify:section:load', () => enableZoomOnHover(2));
document.addEventListener('shopify:section:reorder', () => enableZoomOnHover(2));
